"use client";

import { memo } from "react";
import { motion } from "framer-motion";
import Link from "@/components/LocalizedLink";
import { useTranslation } from "@/lib/i18n";
import { trackEvent } from "@/lib/analytics";

export const CtaBanner = memo(function CtaBanner() {
  const { t } = useTranslation();

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-background to-accent/5" />
      <div className="absolute inset-0 network-grid opacity-40" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="relative z-10 mx-auto max-w-3xl text-center"
      >
        <h2
          className="font-display text-3xl sm:text-4xl tracking-tight text-foreground mb-4"
          style={{ fontWeight: 600 }}
        >
          {t("cta_heading")}
        </h2>
        <p className="text-lg text-muted-foreground mb-8">
          {t("cta_subtitle")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            href="/#configurator"
            onClick={() => trackEvent("cta_try_naas_configurator", { location: "cta_banner" })}
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium btn-primary rounded-[2px] transition-colors glow-teal"
          >
            {t("try_naas")}
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
          <Link
            href="/contact/"
            onClick={() => trackEvent("cta_contact_us", { location: "cta_banner" })}
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium border border-border text-foreground rounded-[2px] hover:bg-surface-light transition-colors"
          >
            {t("contact_us")}
          </Link>
        </div>
      </motion.div>
    </section>
  );
});
CtaBanner.displayName = "CtaBanner";
